import { Component, OnInit, Inject, ViewChild, ElementRef, Input, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { FormValidatorService } from '../../shared-services/form-validator.service';
import { HistoryProvider } from '../../core/browser-providers';
import { MediaService } from '../../shared-services/media.service';
import { Http } from '@angular/http';
import { NavigationService } from '../../shared-services/navigation.service';
import { NgForm, FormControl } from '@angular/forms';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { Observable } from 'rxjs/Observable';
import { MatAutocompleteSelectedEvent, MatChipInputEvent } from '@angular/material';
import { ENTER } from '@angular/cdk/keycodes';
import { SubcategoriaProducto } from './subcategoria-producto.model';
import { CategoriaProducto } from '../categoria-producto/categoria-producto.model';
import { Sugerencia } from '../sugerencia/sugerencia.model';

@Component({
  selector: 'app-subcategoria-producto-add-edit',
  templateUrl: './subcategoria-producto-add-edit.component.html',
  styleUrls: ['./subcategoria-producto-add-edit.component.scss']
})
export class SubcategoriaProductoAddEditComponent implements OnInit {

  categorias: Observable<CategoriaProducto[]>;
  sugerencias: Observable<Sugerencia[]>;
  _selectedCategorias: CategoriaProducto[] = [];
  separatorKeysCodes: number[] = [ENTER];

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  @ViewChild('form') public roleForm: NgForm;
  toppings = new FormControl();
  @ViewChild('fruitInput') fruitInput: ElementRef;

  validationFail = false;
  item: SubcategoriaProducto;

  messageTitle: string;

  isHD = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private snackService: SnackService,
    private backendService: BackendService,
    private formValidatorService: FormValidatorService,
    private renderer: Renderer2,
    @Inject(HistoryProvider) private history: History,
    private http: Http,
    private mediaService: MediaService,
    private navigationService: NavigationService,
    private dialogService: DialogService,
  ) { }

  ngOnInit() {

    this.getCategorias();
    this.getSugerencias();
    this.route.data.subscribe(data => {
      this.item = data.user;
      this.item.description = this.item.id ? this.item.description : '';
      if (!this.item.categorias) {
        this.item.categorias = [];
      }
      if (!this.item.sugerencias) {
        this.item.sugerencias = [];
      }
    });

    this.messageTitle = this.item.id  ? 'Edición de Subcategoría' : 'Alta de Subcategoría';

    this.mediaService.isHighDefinition.subscribe(isHD => this.isHD = isHD);
  }

  async getCategorias() {
    this.categorias = this.backendService.get(CategoriaProducto, CategoriaProducto.path, {});
  }

  async getSugerencias() {
    this.sugerencias = this.backendService.get(Sugerencia, Sugerencia.path, {});
  }

  back() {
    this.navigationService.back();
  }

  remove(categoria: CategoriaProducto): void {

    const index = this.item.categorias.indexOf(categoria);
    if (index >= 0) {
      this.item.categorias.splice(index, 1);
    }
    this.filter();
  }

  selected(event: MatAutocompleteSelectedEvent): void {

    const index = this.item.categorias.indexOf(event.option.value);

    if (index >= 0) {
      return;
    }
    this.item.categorias.push(event.option.value);
    this.fruitInput.nativeElement.value = '';
    this.toppings.setValue(null);
    // this.renderer.invokeElementMethod(this.fruitInput.nativeElement, 'blur', []);
    this.filter();
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
  }

  public categoriaSelected(cate: CategoriaProducto): boolean {
    for (const sugCate of this.item.categorias) {
      if (cate.id === sugCate.id) {
        return true;
      }
    }
    return false;
  }

  private filter() {
    this.categorias
    .map(r => r.filter(p => this._selectedCategorias.indexOf(p) === 0));
  }
  async save() {
    if (this.validateForm()) {
      this.invokeSave();
    }
  }

  validateForm() {
    let validationsOK = false;

    // Valida el resto de los controles con sus validadores
    if (this.formValidatorService.isFormValid(this.roleForm)) {
      validationsOK = true;
      this.validationFail = false;
    } else {
      validationsOK = false;
      this.validationFail = true;
    }

    return validationsOK;
  }

  private async invokeSave() {

    if (this.validateForm()) {
      this.ConfirmSave();
    }

    return;
  }

  async ConfirmSave() {
    this.dialogService.confirm(this.messageTitle,
    '¿Está seguro que desea guardar la subcategoría ' + this.item.description + '?')
    .then( res => {
      if (res) {
        this.saveItem(res);
      }
    });
  }

  cambiarPreciosCategoria(){
    
  }

  async saveItem(res) {
    if (res) {

      this.snackService.spinner(true);

      if (this.item.id) { // Update
        try {
          await await this.backendService.update(SubcategoriaProducto.path + this.item.id, this.item);
          this.snackService.success('Subcategoría editada');
          this.router.navigate(['/subcategorias']);
        } catch (ex) {
          this.snackService.error(ex.message);
        } finally {
          this.snackService.spinner(false);
        }
      } else {
        try {
          await this.backendService.create(SubcategoriaProducto.path, this.item);
          this.snackService.success('Subcategoria creada');
          this.router.navigate(['/subcategorias']);
        } catch (ex) {
          this.snackService.error(ex.message);
        } finally {
          this.snackService.spinner(false);
        }
      }
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/productos/subcategoria-producto/subcategoria-producto-add-edit.component.ts